import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useSelector, shallowEqual } from "react-redux";
import * as apiLearning from "../../../api/learning";
import LearningModule from "../components/LearningModule";
import VideosList from "./VideosList";
import { useIsMobile } from "../../../useIsMobile";

export default function LearningVideos() {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const { authToken } = useSelector(({ auth }) => auth, shallowEqual);
  const [quiz, setQuiz] = useState(null);
  const [loadingQuiz, setLoadingQuiz] = useState(false);
  const isMobile = useIsMobile();



  useEffect(() => {
    let active = true;
    const load = async () => {
      if (!authToken || !selectedVideo?.id) {
        setQuiz(null);
        return;
      }
      setLoadingQuiz(true);
      try {
        const res = await apiLearning.getQuizByVideo(authToken, selectedVideo.id);
        const q = res?.quiz;
        if (q && q.json) {
          const parsed = JSON.parse(q.json);
          if (active) setQuiz(parsed);
        } else {
          if (active) setQuiz(null);
        }
      } catch {
        if (active) setQuiz(null);
      } finally {
        if (active) setLoadingQuiz(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [authToken, selectedVideo?.id]);
  

  return (
    <div className="tw:container tw:mx-auto tw:px-4 tw:py-8">
      {/* <h1 className="tw:text-2xl tw:font-semibold tw:mb-6">E-Learning</h1> */}
      <VideosList onSelect={(video) => setSelectedVideo(video)} />
      {selectedVideo && !loadingQuiz && quiz && createPortal(
        <div 
          className="tw:fixed tw:inset-0 tw:z-[100000] tw:flex tw:items-center tw:justify-center tw:bg-black/60 tw:backdrop-blur-sm"
          style={{ zIndex: 100000, backgroundColor: 'rgba(0,0,0,0.6)' }}
        >
          <div 
            className="tw:p-4 tw:relative tw:bg-white tw:rounded-xl tw:shadow-2xl tw:flex tw:flex-col tw:overflow-hidden"
            style={{ 
              borderRadius: '16px',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
              backgroundColor: '#ffffff',
              //  La dimensione deve essere di 16/9 per evitare distorsioni
              width: '80vw',
              height: isMobile ? '80vh' : 'calc(80vw * 9 / 16)'
            }}
          >
            {/* Header del popup */}
            <div className="tw:flex tw:items-center tw:justify-between tw:px-6 tw:py-4 tw:border-b tw:border-gray-100 tw:bg-gray-50/50">
              <h3 className="tw:text-lg tw:font-semibold tw:text-gray-800 tw:truncate">
                {selectedVideo.title}
              </h3>
              <button
                onClick={() => setSelectedVideo(null)}
                className="tw:p-2 tw:text-gray-400 hover:tw:text-gray-600 hover:tw:bg-gray-100 tw:rounded-full tw:transition-colors"
                title="Chiudi"
              >
                <svg className="tw:w-6 tw:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Contenuto scrollabile */}
            <div className="tw:flex-1 tw:overflow-y-auto" style={{ flex: '1 1 0%', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
              <LearningModule video={selectedVideo} quiz={quiz} />
            </div>
          </div>
        </div>,
        document.body
      )}
      {selectedVideo && loadingQuiz && (
        <div className="tw:mt-8 tw:p-4 tw:bg-gray-50 tw:text-gray-700 tw:rounded">Caricamento quiz...</div>
      )}
      {selectedVideo && !loadingQuiz && !quiz && (
        <div className="tw:mt-8 tw:p-4 tw:bg-yellow-50 tw:text-yellow-800 tw:rounded">
          Nessun quiz disponibile per questo video.
        </div>
      )}
    </div>
  );
}
